import React from 'react';
import PropTypes from 'prop-types';

const AuditCard = ({
  pmoScore,
  qualityScore,
  techScore,
  pmoDate,
  qualityDate,
  techDate,
  canViewAudit,
}) => {
  const maskedPmoScore = canViewAudit ? pmoScore : null;
  const maskedQualityScore = canViewAudit ? qualityScore : null;
  const maskedTechScore = canViewAudit ? techScore : null;
  const maskedPmoDate = canViewAudit ? pmoDate : '-';
  const maskedQualityDate = canViewAudit ? qualityDate : '-';
  const maskedTechDate = canViewAudit ? techDate : '-';

  const getAuditClass = (score) => {
    if (score === null || score === undefined) return '';
    if (score >= 8) return 'green';
    if (score >= 7) return 'yellow';
    return 'red';
  };
  const pmoClass = getAuditClass(maskedPmoScore);
  const qualityClass = getAuditClass(maskedQualityScore);
  const techClass = getAuditClass(maskedTechScore);

  return (
    <div className="card audit-card">
      <div className="card-header">
        <h3 className="card-title">Audit</h3>
        <span className="divider" />
      </div>
      <div className="card-content">
        <div className="audit-items">
          <div className="audit-item">
            <span className="audit-label">PMO:</span>
            <span className={`audit-score ${pmoClass}`}>
              {maskedPmoScore == null ? '-' : maskedPmoScore.toFixed(2)}
            </span>
            <span className="audit-date">({maskedPmoDate ?? '-'})</span>
          </div>
          <div className="audit-item">
            <span className="audit-label">Quality:</span>
            <span className={`audit-score ${qualityClass}`}>
              {maskedQualityScore == null ? '-' : maskedQualityScore.toFixed(2)}
            </span>
            <span className="audit-date">({maskedQualityDate ?? '-'})</span>
          </div>
          <div className="audit-item">
            <span className="audit-label">Tech:</span>
            <span className={`audit-score ${techClass}`}>
              {maskedTechScore == null ? '-' : maskedTechScore.toFixed(2)}
            </span>
            <span className="audit-date">({maskedTechDate ?? '-'})</span>
          </div>
        </div>
      </div>
    </div>
  );
};

AuditCard.propTypes = {
  pmoScore: PropTypes.number,
  qualityScore: PropTypes.number,
  techScore: PropTypes.number,
  pmoDate: PropTypes.string,
  qualityDate: PropTypes.string,
  techDate: PropTypes.string,
  canViewAudit: PropTypes.bool,
};

AuditCard.defaultProps = {
  pmoScore: null,
  qualityScore: null,
  techScore: null,
  pmoDate: null,
  qualityDate: null,
  techDate: null,
  canViewAudit: false,
};

export default AuditCard;
